export interface LoginResult {
  status: 'OK' | 'ERROR';
  message: string;
}
